import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useAuth } from "@/auth/use-auth";

export const Route = createFileRoute("/auth/redeem")({
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === "string" ? search.token : "",
  }),
  component: RedeemPage,
});

function RedeemPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const { token } = Route.useSearch();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setError("missing token");
      return;
    }
    void (async () => {
      try {
        await auth.redeemMagicLink(token);
        await navigate({ to: "/" });
      } catch (err) {
        const msg = err instanceof Error ? err.message : "sign-in failed";
        if (msg === "admin_only") {
          setError("This email is not authorized for admin access.");
        } else {
          setError(msg);
        }
      }
    })();
  }, [auth, navigate, token]);

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="rounded-lg border border-zinc-200 bg-white p-6 text-center shadow-sm">
        {error ? (
          <>
            <p className="text-sm font-semibold text-red-600">Sign-in failed</p>
            <p className="mt-2 text-sm text-zinc-600">{error}</p>
            <a
              href="/admin/login"
              className="mt-4 inline-block text-sm text-zinc-700 underline"
            >
              Back to sign-in
            </a>
          </>
        ) : (
          <p className="text-sm text-zinc-600">Signing you in…</p>
        )}
      </div>
    </div>
  );
}
